import { parseApiError } from '@cast/api-client';
import { Dialog, Typography, tokens } from '@cast/design-system';
import { Organization } from '@cast/types';

import { useCreateOrganizationMutation } from '../../mutations/useCreateOrganizationMutation';
import {
  CreateOrganizationAsEnum,
  OrganizationFormValues,
} from '../../types/create-organization';
import { OrganizationForm } from '../../_components/OrganizationForm';

import { useCreateChildOrganizationMutation } from '../../mutations/useCreateChildOrganizationMutation';

type Props = {
  destroy: (organization?: Organization, isChild?: boolean) => void;
  enterpriseOrgId?: string;
};

export const CreateOrganizationDialog = ({
  destroy,
  enterpriseOrgId,
}: Props) => {
  const {
    mutate: createOrganization,
    isPending,
    error,
  } = useCreateOrganizationMutation();
  const {
    mutate: createChildOrganization,
    isPending: isChildPending,
    error: childError,
  } = useCreateChildOrganizationMutation();

  const handleSubmit = (payload: OrganizationFormValues) => {
    if (
      payload.createOrganizationAs === CreateOrganizationAsEnum.CHILD &&
      payload.enterpriseId
    ) {
      createChildOrganization(
        {
          name: payload.name,
          enterpriseId: payload.enterpriseId,
        },
        {
          onSuccess: async ({ data: organization }) => {
            destroy(organization as Organization, true);
          },
        }
      );
    } else {
      createOrganization({ name: payload.name } as Organization, {
        onSuccess: async ({ data: organization }) => {
          destroy(organization as Organization);
        },
      });
    }
  };

  return (
    <Dialog
      aria-label="Setup organization dialog"
      open={true}
      fullWidth
      maxWidth="sm"
      onClose={() => destroy()}
      testId="create-organization-dialog"
    >
      <OrganizationForm
        onSubmit={handleSubmit}
        onCancel={() => destroy()}
        submitting={isPending || isChildPending}
        errors={
          error || childError ? parseApiError(error || childError) : undefined
        }
        enterpriseOrgId={enterpriseOrgId}
      >
        <Typography variant="h4" color={tokens.theme.fg.structural.primary}>
          Create new organization
        </Typography>
        <Typography
          variant="P14R"
          color={tokens.theme.fg.structural.secondary}
          mt={4}
        >
          Create a new organization and invite your team. Use and identifiable
          name for your organization.
        </Typography>
      </OrganizationForm>
    </Dialog>
  );
};
